<form [formGroup]="updateUserForm" (ngSubmit)="updateUserFormSub()">
    <div class="p-0">
    <mat-divider></mat-divider>
      <div class="form-row mt-4 mb-4">
        <div class="form-group p-0 col-md-5">
          <label class="label-cls required">No. of Users</label>
          <input class="form-control" name="users" pattern="^[0-9]*$" formControlName="users" type="text"
            placeholder="No. of Users" />
          <span class="invalid-message" *ngIf="(updateUserForm.get('users').touched && updateUserForm.get('users').errors?.required)">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span> 
          <span class="invalid-message"
            *ngIf="updateUserForm.get('users').touched  && updateUserForm.get('users').errors?.pattern">
            {{getGlobalErrorMessages('INVALID_NUMBER')}}
            </span>
        </div>
      </div> 
      <mat-divider></mat-divider>
      <div class="d-flex justify-content-end align-items-center mt-3">
        <button class="btn cancelBtn mr-4" type="button" (click)="closeDialog()">Cancel</button>
        <button class="btn btn-primary" type="submit" [disabled]="updateUserForm.invalid">Update</button>
      </div>
    </div>
</form>